import MicroModal from 'micromodal';

function initPricingFormModal() {
    const pricingFormModal = document.querySelector('.pricing-contact-form-modal');
    const pricingCalc = document.querySelector(".pricing-calculator");
    const contactBtns = document.querySelectorAll('.pricing-calc-submit-btn');

    /* Gravity forms fields */
    let employeeField = document.querySelector('#input_6_8');
    let editingRightsField = document.querySelector('#input_6_9');
    let viewingRightsField = document.querySelector('#input_6_10');
    let countriesField = document.querySelector('#input_6_11');
    let extrasField = document.querySelector('#input_6_12');
    let buttonClickedField = document.querySelector('#input_6_13');
    let estimatedPriceField = document.querySelector('#input_6_14');

    let btnPressed = '';

    contactBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            btnPressed = btn.id;
        });
    });

    function updateGravityFormFields() {
        const inputData = JSON.parse(pricingCalc.dataset.inputData);
        const priceBasic = pricingCalc.querySelector(".pricing-result-basic");
        const priceExtended = pricingCalc.querySelector(".pricing-result-extended");
        const pricePremium = pricingCalc.querySelector(".pricing-result-premium");

        employeeField.value = inputData.employees;
        editingRightsField.value = inputData.editors;
        viewingRightsField.value = inputData.viewers;
        countriesField.value = inputData.countries.value;
        extrasField.value = inputData.extras;
        buttonClickedField.value = btnPressed;

        if (btnPressed === 'basic') {
            estimatedPriceField.value = priceBasic.innerText;
        } else if (btnPressed === 'extended') {
            estimatedPriceField.value = priceExtended.innerText;
        } else if (btnPressed === 'premium') {
            estimatedPriceField.value = pricePremium.innerText;
        } else {
            estimatedPriceField.value = `Basic: ${priceBasic.innerText} \n Extended: ${priceExtended.innerText} \n Premium: ${pricePremium.innerText}`;
        }
    }

    if (pricingFormModal) {

        MicroModal.init({
            disableScroll: true,
            onShow: modal => {
                updateGravityFormFields();
            }, // [1]
            onClose: modal => {
            }, // [1]
        });
    }
}

export default initPricingFormModal;